<template>

  <el-form inline label-width="80px" size="small" label-position="left">
    <el-form-item label="数据类型">
      <el-radio-group v-model="ele.dataset.type" @change="handleDatasetChange">
        <el-radio label="表单" value="form"></el-radio>
        <el-radio label="ETL Model" value="etl"></el-radio>
      </el-radio-group>
    </el-form-item>
  </el-form>

  <el-form inline label-width="80px" size="small" label-position="left">
    <el-form-item v-if="ele.dataset.type==='form'" label="数据源">
      <form-select v-model="ele.dataset.source" @change="(val)=>$emit('handleFormChange',val)"></form-select>
    </el-form-item>
    <el-form-item v-if="ele.dataset.type==='etl'" label="数据源">
      <elt-package-select v-model="ele.dataset.source" @change="(val)=>$emit('handleFormChange',val)"></elt-package-select>
    </el-form-item>
  </el-form>

</template>


<script>
import FormSelect from "@/components/common/formSelect.vue";
import EltPackageSelect from "@/components/common/eltPackageSelect.vue";

export default {
  emits: ['handleFormChange','handleEtlPackageChange'],
  components: {
    EltPackageSelect,
    FormSelect
  },
  props: {
    element: {
      type: Object
    }
  },
  data() {
    return {
      ele: null
    }
  },
  created() {
    this.ele = this.element;
  },
  methods: {
    handleDatasetChange() {
      this.ele.dataset.source = '';
      this.ele.dataset.dimensions = [];
      this.ele.dataset.indices = [];
      this.ele.dataset.dates = [];
    },
  }


}


</script>

<style scoped lang="scss">

</style>